import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Copysa from "../../assets/copysa.svg";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import HelpIcon from "@mui/icons-material/Help";
import TemporaryDrawer from "../Sidebar/index";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { useSelector } from "react-redux";
import SchoolIcon from "@mui/icons-material/School";
import { useTranslation } from "react-i18next";
export default function Header() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === "fa" ? "Fa" : "En";
  const renderModalContent = () => {
    const centeredBoxStyle = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center", // Ensures text is centered within the Box
      my: 2, // Adds margin to create space
    };
    const getImg = (name) => `images/tutorial/${name}${lang}.webp`;

    switch (location.pathname) {
      case "/":
        return (
          <Box sx={centeredBoxStyle}>
            <Typography id="modal-modal-description" sx={{ mb: 3 }}>
              {t("Tutorial.AddDoc")}
            </Typography>
            <img
              src={getImg("1")}
              alt="first step tutorial"
              className="!w-[234px] !h-[415px] my-2 rounded-xl"
            />

            <Typography id="modal-modal-description" sx={{ my: 2 }}>
              {t("Tutorial.UseCodeOrQR")}
            </Typography>
            <img
              src={getImg("2")}
              alt="first step tutorial"
              className="!w-[234px] !h-[415px] my-2 rounded-xl"
            />

            <Typography id="modal-modal-description" sx={{ mb: 1 }}>
              {t("Tutorial.OTPNote")}
            </Typography>
            <img
              src={getImg("7")}
              alt="first step tutorial"
              className="!w-[234px] !h-[415px] my-2 rounded-xl"
            />
          </Box>
        );
      case "/upload":
        return (
          <Box sx={centeredBoxStyle}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {t("Tutorial.UploadFormats")}
            </Typography>
            <img
              src={getImg("2")}
              alt="first step tutorial"
              className="!w-[234px] !h-[415px] my-2 rounded-xl"
            />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {t("Tutorial.UseCamera")}
            </Typography>
            <img
              src={getImg("phone")}
              alt="first step tutorial"
              className="!w-[234px] !h-[415px] my-4 rounded-xl"
            />
            <Typography id="modal-modal-description" sx={{ mb: 2 }}>
              {t("Tutorial.CropFeature")}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {t("Tutorial.NextSteps")}
            </Typography>
            <img
              src={getImg("3")}
              alt="first step tutorial"
              className="!w-[234px] !h-[415px] my-2 rounded-xl"
            />
            <Typography>{t("Tutorial.FinishProcess")}</Typography>
            <img
              src={getImg("4")}
              alt="first step tutorial"
              className="!w-[234px] !h-[415px] my-2 rounded-xl"
            />
            <Typography>{t("Tutorial.ConfirmInfo")}</Typography>
            <img
              src={getImg("5")}
              alt="first step tutorial"
              className="!w-[234px] !h-[415px] my-2 rounded-xl"
            />
            <Typography>{t("Tutorial.Done")}</Typography>
          </Box>
        );
      case "/about":
        return (
          <Box sx={centeredBoxStyle}>
            <Typography id="modal-modal-description" sx={{ my: 1 }}>
              {t("Tutorial.Contact")}
            </Typography>
          </Box>
        );
      case "/profile":
        return (
          <Box sx={centeredBoxStyle}>
            <Typography id="modal-modal-description" sx={{ my: 1 }}>
              {t("Tutorial.Profile")}
            </Typography>
          </Box>
        );
      case "/device":
        return (
          <Box sx={centeredBoxStyle}>
            <Typography id="modal-modal-description" sx={{ my: 1 }}>
              {t("Tutorial.Device")}
            </Typography>
          </Box>
        );
      case "/history":
        return (
          <Box sx={centeredBoxStyle}>
            <Typography id="modal-modal-description" sx={{ my: 1 }}>
              {t("Tutorial.History")}
            </Typography>
          </Box>
        );
      case "/agreement":
        return (
          <Box sx={centeredBoxStyle}>
            <Typography id="modal-modal-description" sx={{ my: 1 }}>
              {t("Tutorial.Agreement")}
            </Typography>
          </Box>
        );
      default:
        return (
          <Box sx={centeredBoxStyle}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {t("Tutorial.NotFound")}
            </Typography>
            <Typography id="modal-modal-description" sx={{ my: 1 }}>
              {t("Tutorial.NotFoundDesc")}
            </Typography>
          </Box>
        );
    }
  };

  const Titles = {
    upload: t("Header.Upload"),
    about: t("Header.About"),
    device: t("Header.Device"),
    history: t("Header.History"),
    profile: t("Header.Profile"),
    setting: t("Sidebar.Setting"),
    support: t("Header.Support"),
    ticket: t("Header.Ticket"),
    letter: t("Header.Letter"),
    addletter: t("Header.Letter"),
    adjustment: t("Header.Adjustment"),
    tutorial: t("Header.Tutorial"),
    "tutorial/": t("Header.Tutorial"),
    agreement: t("Header.Agreement"),
    default: t("Header.Default"),
  };
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { type } = useSelector((state) => state.user);

  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";
  const isSanadRoute = location.pathname.startsWith("/sanad");
  const isSupportRoute = location.pathname.startsWith("/support");

  const getPage = () => {
    const path = location.pathname.slice(1);
    const decodedPath = decodeURIComponent(path);

    const title = Titles[decodedPath] || Titles["default"]; // Use default title if not found
    return title;
  };

  const [state, setState] = useState({ left: false, right: false });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const style = {
    position: "absolute",
    flexDirection: "column",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 3,
    pt: 1,
    pl: 2,
    borderRadius: "10px",
    direction: "ltr",
    minWidth: "300px",
    maxWidth: { xs: "350px", md: "initial" },
    maxHeight: { xs: "650px", md: "85%" },
    overflow: "auto",
  };
  const goBackOrHome = () => {
    // Define specific navigation paths for each route
    const routeNavigationMap = {
      "/support/": "/support",
      "/addletter": "/letter",
      "/profile": "/",
      "/agreement": "/",
      "/ticket": "/support",
      "/history": "/",
      "/adjustment": "/letter",
      "/letter": "/",
      // Add more routes as needed
    };

    const currentPath = location.pathname;

    // Check if current path matches any route in the map
    const targetPath = Object.keys(routeNavigationMap).find((route) =>
      currentPath.startsWith(route)
    );

    if (targetPath) {
      navigate(routeNavigationMap[targetPath]);
    } else {
      // Default: navigate to home
      navigate("/");
    }
  };

  return (
    <Box dir="rtl">
      {isHome ? (
        <AppBar
          dir="rtl"
          className="flex flex-row items-center justify-between bg-purple p-3 text-ice-white sticky mb-7"
          style={{ flexFlow: "row nowrap" }}
        >
          <IconButton
            onClick={toggleDrawer("right", true)}
            aria-label="Open menu"
          >
            <MenuIcon sx={{ color: "white" }} fontSize="medium" />
          </IconButton>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              {renderModalContent()}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 5,
                  width: "100%",
                }}
              >
                <div>
                  <Button variant="outlined" onClick={handleClose}>
                    {t("Common.Close")}
                  </Button>
                </div>
              </Box>
            </Box>
          </Modal>

          <TemporaryDrawer
            sx={{ color: "white" }}
            state={state}
            setState={setState}
            toggleDrawer={toggleDrawer}
          />
          <img src={Copysa} alt="copysa logo" width={150} loading="lazy" />
          <Box display="flex">
            {type === 2 ? (
              <IconButton
                component="a"
                href="https://edu.copysa.ir/"
                rel="noopener noreferrer"
                aria-label="Open Student panel"
              >
                <SchoolIcon sx={{ color: "white" }} fontSize="medium" />
              </IconButton>
            ) : null}
            <IconButton onClick={handleOpen}>
              <HelpIcon sx={{ color: "white" }} fontSize="medium" />
            </IconButton>
          </Box>
        </AppBar>
      ) : (
        <AppBar
          dir="ltr"
          className="flex flex-row items-center justify-between bg-purple p-3 text-ice-white sticky"
          style={{ flexFlow: "row-reverse nowrap" }}
        >
          <IconButton onClick={goBackOrHome} aria-label="Go back">
            <EastIcon sx={{ color: "white" }} fontSize="medium" />
          </IconButton>
          <TemporaryDrawer
            sx={{ color: "white" }}
            state={state}
            setState={setState}
            toggleDrawer={toggleDrawer}
          />
          <Typography variant="h1">
            {isSanadRoute
              ? t("Header.List")
              : isSupportRoute
              ? t("Header.Support")
              : getPage()}
          </Typography>
          <Box display="flex">
            <IconButton onClick={handleOpen}>
              <HelpIcon sx={{ color: "white" }} fontSize="medium" />
            </IconButton>
            {type === 2 ? (
              <IconButton
                component="a"
                href="https://edu.copysa.ir/"
                rel="noopener noreferrer"
                aria-label="Open Student panel"
              >
                <SchoolIcon sx={{ color: "white" }} fontSize="medium" />
              </IconButton>
            ) : null}
          </Box>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              {renderModalContent()}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 3,
                  width: "100%",
                }}
              >
                <Button variant="outlined" onClick={handleClose}>
                  {t("Common.Close")}
                </Button>
              </Box>
            </Box>
          </Modal>
        </AppBar>
      )}
    </Box>
  );
}
